<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col text-center">
                            <h4>Access to HADRaaS Requires a VPN</h4>
                            <p>Follow the guide below to install and configure the VPN client. Once set up, your login details will be provided by our support team.</p>
                            <div class="flex flex-row gap-8 justify-center">
                                <b-button 
                                    href="https://help.serversaustralia.com.au/s/article/Installing-and-Using-WireGuard" 
                                    target="_blank"
                                    title="Installing and Using WireGuard" 
                                    variant="primary"
                                    >Guide to Setting up VPN</b-button>
                                <b-button 
                                    href="/support/cases/create" 
                                    target="_blank"
                                    title="Open a case to request your HADRaaS login details" 
                                    variant="outline-primary"
                                    >Request Login Details</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row pt-4">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col text-center">
                        <h4>VCenter Login</h4>
                            <p>Open the Console start a remote session</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <sau-service-access></sau-service-access>
                        </div>
                    </div>
                    <div class="row pt-4">
                        <div class="col mx-auto text-center">
                            <a href="https://vcs.hadraas.servercontrol.com.au/ui/" target="_blank" class="btn btn-success text-center">Open Console</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import CommonAccess from '@js/components/service/common/_Access';
export default {
    props: ['service'],
    components: {
        'sau-service-access': CommonAccess
    },
}
</script>
